export const XLS_CONTENT_TYPE = 'application/vnd.ms-excel';
export const XLSX_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const XLSM_CONTENT_TYPE = 'application/vnd.ms-excel.sheet.macroEnabled.12';
export const ODS_CONTENT_TYPE = 'application/vnd.oasis.opendocument.spreadsheet';

export const MS_OFFICE_EXCEL_MIME_TYPES = [
  XLS_CONTENT_TYPE,
  XLSX_CONTENT_TYPE,
  XLSM_CONTENT_TYPE,
];

export const SPREADSHEET_WORKBOOK_MIME_TYPES = [...MS_OFFICE_EXCEL_MIME_TYPES, ODS_CONTENT_TYPE];
